<script setup lang="ts">
import ListItem from '@/components/ui/ListItem.vue';
import RouteBadge from '@/components/ui/RouteBadge.vue';
import BookmarkButton from '@/components/ui/BookmarkButton.vue';
import { AppRoute } from '@/libs/routing';
import type { Route, Stop } from '@/@types/gtfs-ressource';

const props = defineProps<{
  stop: Stop;
  routes: Route[];
}>();
</script>

<template>
  <router-link :to="{ name: AppRoute.STOP_DETAILED, params: { stopId: stop.stop_id } }" class="stop-item">
    <ListItem :label="props.stop.stop_name">
      <template v-if="routes?.length" #badges>
        <RouteBadge v-for="route in props.routes" :key="route.route_id" :route="route" size="small" />
      </template>
      <template #trailing>
        <BookmarkButton :element="stop" />
      </template>
    </ListItem>
  </router-link>
</template>

<style lang="scss">
.stop-item {
  display: block;

  &:active .list-item {
    background-color: $color-neutral-lower;
  }
}
</style>
